// Account Payable Payments Vuex

import state from './paymentStates.js'
import * as getters from './paymentGetters.js'
import * as mutations from './paymentMutations.js'
import * as actions from './paymentActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
